var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayButton = function SvgIconPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPlayButton_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.395 10.122-5.192-2.843a2.13 2.13 0 0 0-2.138.017 2.13 2.13 0 0 0-1.064 1.855v5.699c0 .772.397 1.465 1.064 1.855a2.118 2.118 0 0 0 2.128.023l5.212-2.854a2.12 2.12 0 0 0 1.096-1.873c0-.787-.409-1.487-1.105-1.878zm-.961 2.003-5.212 2.855c-.019.01-.077.042-.147-.001-.074-.043-.074-.107-.074-.128V9.152c0-.021 0-.085.074-.128a.14.14 0 0 1 .074-.021.2.2 0 0 1 .083.026l5.192 2.844c.019.011.076.043.076.13s-.058.119-.066.125zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPlayButton_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPlayButton;